module.exports = __webpack_public_path__ + "img/moavagh-list.56141d0f.jpg";